import React from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

export const Toast = ({ message, type }) => {
  if (!message) return null;
  return (
    <div className={`fixed top-6 left-1/2 -translate-x-1/2 z-[100] px-6 py-3 rounded-2xl border-2 border-gray-900 font-black text-xs uppercase tracking-widest flex items-center gap-3 shadow-[4px_4px_0px_0px_rgba(17,24,39,1)] animate-in fade-in slide-in-from-top-5 ${type === 'error' ? 'bg-rose-400 text-gray-900' : 'bg-[#e2ff4c] text-gray-900'}`}>
      {type === 'error' ? <AlertCircle size={16} /> : <CheckCircle2 size={16} />} 
      {message}
    </div>
  );
};